import LogoLink, { LogoLinkProps } from './LogoLink';

export default LogoLink;

export type { LogoLinkProps };
